<template>
    <div id="Photovoltaic">
        <div class="subcontainer-one column-center"  >
           <!-- <div class="column-center wapp" :class="{'full':isFull,'kuan':iskuan}">
                <div class="site">
                    <span v-for="(item,index) in siteList" :key="index" :class="active==index?'active':''" @click="tagsite(index)">{{item.name}}</span>
                </div>
                <div class="diagram">
                    <iframe ref="iframe" height="100%" width="100%"  class="small" src="https://local.vrmaker.com.cn/wiring/ch/CH-ZCT-6.html" frameborder="0"></iframe>
                    <div class="handel">
                        <img src="@/assets/img/kuan.png" alt=""  v-if="!isFull"  @click="kuan">
                        <img src="@/assets/img/quan.png" alt="" v-if="!iskuan"  @click="full">
                    </div>
                </div>
           </div> -->
           <pvWiringLine></pvWiringLine>
        </div>
        <div class="subcontainer-thr">
            <Diagram></Diagram>
        </div>
    </div>
</template>

<script>
import Park from "../../components/common/Park";
import Diagram from "./components/Diagram";
import pvWiringLine from "./components/pvWiringLine.vue";
import Monitor from "../../components/common/Monitor";
export default {
    data(){
        return {
            isFull:false,
            iskuan: false,
            active:0,
            siteList:[]
        }
    },
    components:{
        Park,Monitor,Diagram,pvWiringLine
    },
    computed:{
       
    },
    created(){
        this.$store.commit('setAreaId', this.$store.getters.getTypeSite('photovoltaic')[0].areaId)
        this.$store.commit("setAreaInfo",this.$store.getters.getTypeSite('photovoltaic')[0]);
    },
    methods:{
        
        tagsite(index){
            this.active = index
        },
        kuan(){
            this.iskuan = !this.iskuan
        },
        full() {
            this.isFull = !this.isFull
        },
    }
}
</script>

<style lang="less" scoped>
    
    #Photovoltaic{
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        justify-content: space-between;
        align-content: space-between;
        position: relative;
        .subcontainer-one{
            // padding: 1.5vh 5.2vw;
            .h(648);
            .w(1194);
            background: #fff;
            // display: flex;
            // flex-wrap: wrap;
            // align-items: center;
        }
        
        .subcontainer-thr{
            .h(320);
            .w(1194);
            // background: #FFFFFF;
        }
    }
</style>